export default {"src":"/_next/static/media/KeepaWhiteLogoRight.a37c35f4.svg","height":23,"width":95};